export default "__VITE_ASSET__FSNpkZz$__"